import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { taskManagerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const RedeemTask = () => {

  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tastManager;
  const contract = taskManagerContract(tokenAddress, web3);


  const redeemTask = useCallback(
    async (creater, personalsing) => {
      console.log(creater?.signedKeyDetails?.taskId, 0, creater?.signedKeyDetails?.deadline, creater?.creatorSignature, creater?.signedKeyDetails?.signerSignature, 'redeemTask payload 1');
      try {
        const gas = await contract.methods.processTaskAction(creater?.signedKeyDetails?.taskId, 0, creater?.signedKeyDetails?.deadline, creater?.creatorSignature, creater?.signedKeyDetails?.signerSignature).estimateGas({
          from: account
        });
        const details = await contract.methods.processTaskAction(creater?.signedKeyDetails?.taskId, 0, creater?.signedKeyDetails?.deadline, creater?.creatorSignature, creater?.signedKeyDetails?.signerSignature).send({
          from: account,
          gas,
        });
        return details;
      } catch (error) {
        console.log('errorr redeemTask', error);

        throw error;
      }
    },
    [contract, account]
  );
  return { redeemTask: redeemTask };
};
export default RedeemTask;